import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    background: '#FFFFFF',
    position: 'relative',
  },

  headerWrapper: {
    padding: '25px',
    boxSizing: 'border-box',
    width: '100%',
    boxShadow: '0px 1px 0px #00000029',
  }
});

class Header extends React.Component {
  render () {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.headerWrapper}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
}

PropTypes.defaultValue = {
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/Header.jsx